module.exports = __webpack_public_path__ + "img/profile-man-14-min.bafeabea.jpg";